import {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {ACCOUNT, checkScreenSize, STORAGE_KEY} from "utils";
import View from "./View";
import {changeSidePanel} from "store/actions/sidePanel";

const Container = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const token = searchParams.get("token");
  const isPc = checkScreenSize(768);
  const [screenSize, setScreenSize] = useState(window.innerWidth);

  const [sideType, setSideType] = useState(ACCOUNT.SIGN_IN);
  const [sideProps, setSideProps] = useState({});
  const dispatch = useDispatch();
  const handleSideType = (type, props) => {
    setSideType(type);
    setSideProps(props);
    dispatch(changeSidePanel({type}));
  };

  const mobileFullScreen = () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  };

  const setTokenForLogin = () => {
    if (token) {
      localStorage.setItem(STORAGE_KEY.REDBRICK_TOKEN, token);
      searchParams.delete("token");
      window.history.pushState(null, null, `?${searchParams}`);
      window.location.reload(true);
    }
  };

  useEffect(() => {
    setTokenForLogin();

    new ResizeObserver(() => {
      mobileFullScreen();
    }).observe(document.body);

    window.addEventListener("orientationchange", mobileFullScreen);
    return () => window.removeEventListener("orientationchange", mobileFullScreen);
  }, []);

  const resizeScreen = () => {
    setScreenSize(window.innerWidth);
  };

  useEffect(() => {
    new ResizeObserver(() => {
      resizeScreen();
    }).observe(document.body);
  }, []);

  return <View isPc={isPc} screenSize={screenSize} sideProps={sideProps} sideType={sideType} handleSideType={handleSideType} />;
};

export default Container;
